import h from 'hyperscript';
import getYouTubeID from 'get-youtube-id';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default';
import $photoswipeTemplate from '../../../javascripts/shared/photoswipe-template';
import { setCookie, getCookie } from '../../../javascripts/utils/cookie';
import { BREAKPOINTS } from '../../../javascripts/constants';

function getVideoIframe(Id) {
  // Construct Youtube iframe player, add rel=0 to disable related video's
  return h('.figure__media.figure__media--16x9', h('iframe.figure__iframe', {
    src: `https://www.youtube.com/embed/${Id}?rel=0`,
    allowFullscreen: true,
    msAllowFullscreen: true,
    webkitAllowFullscreen: true,
    mozAllowFullscreen: true,
  }));
}

function replaceWithVideo($mediaNode) {
  const youtubeId = getYouTubeID($mediaNode.getAttribute('data-video'));
  const $iframe = getVideoIframe(youtubeId);
  // Add iframe to DOM
  $mediaNode.parentNode.replaceChild($iframe, $mediaNode);
}

function removeVideoOverlays() {
  document.querySelectorAll('.figure__media-overlay').forEach((node) => {
    const mediaNode = node.parentNode;
    if (mediaNode) mediaNode.removeChild(node);
    replaceWithVideo(mediaNode);
  });
}

function setVideoPreview($el) {
  const $mediaNode = $el.querySelector('.figure__media');
  const $mediaOverlay = $el.querySelector('.figure__media-overlay');
  let youtubeId;
  let imageUrl;
  if ($mediaNode) {
    youtubeId = getYouTubeID($mediaNode.getAttribute('data-video'));
    imageUrl = `https://img.youtube.com/vi/${youtubeId}/0.jpg`;
  }
  if ($mediaOverlay) $mediaOverlay.style.backgroundImage = `url(${imageUrl})`;
}

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls)); // eslint-disable-line no-param-reassign, no-cond-assign, max-len
  return el;
}

function getMediaQueries() {
  const mediaQuerySmall = window.matchMedia(`(max-width: ${BREAKPOINTS.m}) and (max-width: ${BREAKPOINTS.l})`);
  const mediaQueryMedium = window.matchMedia(`(min-width: ${BREAKPOINTS.m}) and (max-width: ${BREAKPOINTS.l})`);
  const mediaQueryLarge = window.matchMedia(`(min-width: ${BREAKPOINTS.l})`);
  return [mediaQuerySmall, mediaQueryMedium, mediaQueryLarge];
}

let handlePopupKeyDown;
let $overlay;
function focusPopup() {

  if ($overlay.querySelector('.pswp__ui').classList.contains('pswp__ui--one-slide')) {
    $overlay.querySelector('.pswp__button--arrow--left').setAttribute('disabled', 'disabled');
    $overlay.querySelector('.pswp__button--arrow--right').setAttribute('disabled', 'disabled');
  }

  let focusableEls = $overlay.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
  focusableEls = Array.prototype.slice.call(focusableEls);

  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];

  setTimeout(() => {
    firstFocusableEl.setAttribute('tabindex', 1);
    firstFocusableEl.focus();
  }, 500);

  handlePopupKeyDown = function (e) {
    const KEY_TAB = 9;

    function handleBackwardTab() {
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    }

    function handleForwardTab() {
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }

    switch (e.keyCode) {
      case KEY_TAB:
        if (focusableEls.length === 1) {
          e.preventDefault();
          break;
        }

        if (e.shiftKey) {
          handleBackwardTab();
        } else {
          handleForwardTab();
        }
        break;
      default:
        break;
    }
  }

  $overlay.addEventListener('keydown', handlePopupKeyDown);
}

// Show video if cookie is set
document
  .querySelectorAll('.figure--video')
  .forEach(($el) => {
    const cookie = getCookie('allowedVideo');
    if (cookie) removeVideoOverlays();
    setVideoPreview($el);

    if (getMediaQueries()[0].matches) {
      $el.addEventListener('click', (event) => {
        event.preventDefault();
        $el.classList.toggle('figure__media-overlay--mobile');
      });
    }
  });

// Replace video
document
  .querySelectorAll('.js-replace-video')
  .forEach((e) => {
    e.addEventListener('click', (event) => {
      event.preventDefault();
      setCookie('allowedVideo', 'true', 1);
      removeVideoOverlays();
    });
  });

// Resize image
document
  .querySelectorAll('.js-image-resize')
  .forEach((e) => {
    e.addEventListener('click', (event) => {
      event.preventDefault();

      // Get target
      const $target = event.currentTarget;
      const $targetFigure = findAncestor($target, 'figure');
      const $targetFigcaption = $targetFigure && $targetFigure.querySelector('figcaption');

      // Add data-title to target for showing the caption
      $target.setAttribute('data-title', $targetFigcaption ? $targetFigcaption.innerHTML : '');

      // Insert template
      const $template = $photoswipeTemplate.cloneNode(true);
      document.body.appendChild($template);

      const lastFocusedElement =  document.activeElement;


      // Init PhotoSwipe
      const slideshow = new PhotoSwipe(
        $template,
        PhotoSwipeUiDefault,
        [{
          src: $target.getAttribute('href'),
          w: $target.getAttribute('data-width'),
          h: $target.getAttribute('data-height'),
          title: $target.getAttribute('data-title'),
        }],
        {
          index: 0,
          bgOpacity: 0.8,
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          mouseUsed: true,
          fullscreenEl: false,
          zoomEl: false,
          maxSpreadZoom: 1,
          getDoubleTapZoom: (isMouseClick, item) => item.initialZoomLevel,
          pinchToClose: false,
        },
      );

      // After gallery is closed, destory DOM
      slideshow.listen('destroy', () => {
        $template.remove();

        lastFocusedElement.focus();
      });

      // Start gallery
      slideshow.init();

      $overlay = document.querySelector('.pswp');
      focusPopup();

      // Set caption position relative to imagesize
      const setOffsetForCaption = () => {
        const mediaqueries = getMediaQueries();
        let percentage = 0.75;
        if (mediaqueries[0].matches) percentage = 0.75;
        if (mediaqueries[1].matches || mediaqueries[2].matches) percentage = 0.63;
        const initialtopOffset = $template.querySelector('.pswp__scroll-wrap').getBoundingClientRect().width * percentage;
        if ($template.querySelector('.pswp__caption')) {
          $template.querySelector('.pswp__caption').nextSibling.setAttribute('style', `top: ${initialtopOffset}px;`);
        }
      };
      setOffsetForCaption();
      window.addEventListener('resize', () => setOffsetForCaption());
    });
  });



// WEBPACK FOOTER //
// ./src/components/molecules/figure/figure.js